import React from 'react';

const CalendarEmpty = ({
  type = 'empty',
  title,
  message,
  icon,
  action,
  className = '',
}) => {
  const defaultContent = {
    empty: {
      icon: '📅',
      title: 'Brak wydarzeń',
      message: 'Nie ma żadnych wydarzeń w tym okresie.',
    },
    loading: {
      icon: '⏳',
      title: 'Ładowanie...',
      message: 'Pobieranie danych kalendarza.',
    },
    error: {
      icon: '⚠️',
      title: 'Błąd',
      message: 'Nie udało się załadować kalendarza.',
    },
    noTrainer: {
      icon: '👤',
      title: 'Wybierz trenera',
      message: 'Wybierz trenera aby zobaczyć kalendarz.',
    },
    noSelection: {
      icon: '📋',
      title: 'Wybierz opcje',
      message: 'Uzupełnij wymagane pola aby wyświetlić kalendarz.',
    },
  };

  const content = defaultContent[type] || defaultContent.empty;

  return (
    <div className={`calendar-empty ${className}`}>
      <div className="calendar-empty__icon">
        {icon || content.icon}
      </div>

      <div className="calendar-empty__title">
        {title || content.title}
      </div>

      <div className="calendar-empty__message">
        {message || content.message}
      </div>

      {action && (
        <div className="calendar-empty__action">
          {action}
        </div>
      )}
    </div>
  );
};

export default CalendarEmpty;
